import { render, staticRenderFns } from "./Latest.vue?vue&type=template&id=387d0912&scoped=true&"
import script from "./Latest.vue?vue&type=script&lang=js&"
export * from "./Latest.vue?vue&type=script&lang=js&"
import style0 from "./Latest.vue?vue&type=style&index=0&id=387d0912&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d0912",
  null
  
)

export default component.exports